let api_endpoint = "http://localhost:8070/api/";
// let web_socket_endpoint = "ws://localhost:9003"
let web_socket_endpoint = "https://backoffice.zebrain.se/wss";
let coach_host = "http://localhost:1235/";
let localSystem = true;

if (window.location.hostname === "meeting.zebrain.se") {
  api_endpoint = "https://api-dazzle.zebrain.se/api/";
  coach_host = "https://coach.zebrain.se/";
  localSystem = false;
}

export interface AppConfig {
  API_TOKEN: string
  PERSON_TOKEN: string
  USERNAME_TOKEN: string
  API_ENDPOINT: string
  COACH_HOST: string
  WEB_SOCKET_ENDPOINT: string
  AUTH0_CLIENT_ID: string
  MEETING_TYPE: string
  MEETING_KEY: string
  MEETING_WHO: string
  MEETING_USER_ID: string
  MEETING_BACK: string
  LOCAL_SYSTEM: boolean
}

export const CONFIG: AppConfig = {
  API_TOKEN: "api_token",
  PERSON_TOKEN: "person_token",
  USERNAME_TOKEN: "username_token",
  API_ENDPOINT: api_endpoint,
  WEB_SOCKET_ENDPOINT: web_socket_endpoint,
  COACH_HOST: coach_host,
  AUTH0_CLIENT_ID: "Ec9P4CVtrm3cIVjUCNou3BMcXXJIPfjm",
  MEETING_TYPE: "meeting_type",
  MEETING_KEY: "meeting_key",
  MEETING_WHO: "meeting_who",
  MEETING_USER_ID: "meeting_user_id",
  MEETING_BACK: "meeting_back",
  LOCAL_SYSTEM: localSystem,
}